import { createContext, useContext, useState, ReactNode } from "react";

type TimezoneContextType = {
  timezone: string;
  setTimezone: (tz: string) => void;
};

const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const TimezoneContext = createContext<TimezoneContextType>({
  timezone: defaultTimezone,
  setTimezone: () => {},
});

export function TimezoneProvider({ children }: { children: ReactNode }) {
  const [timezone, setTimezone] = useState(defaultTimezone);

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  return useContext(TimezoneContext);
}

export { defaultTimezone };
export default TimezoneContext;
